<template>
  <b-modal
    id="dmCreateEditModal"
    v-model="modalState.isModalOpened"
    :title="isEditMode ? 'Edit row' : 'Add new row'"
    scrollable
    dialog-class="custom__dialog"
    @ok.prevent="onSend"
  >
    <EditSectionsContent
      ref="editContent"
      @changed-row="onChangedRow"
    />
  </b-modal>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import EditSectionsContent from '@/core/components/complex-table/EditSectionsContent.vue';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');

export default {
  name: 'EditSectionsModal',
  components: {
    EditSectionsContent,
  },
  data() {
    return {
      defaultFormBackup: null,
    };
  },
  computed: {
    ...designerMapState({
      modalState: state => state,
      defaultForm: state => state.form,
      isEditMode: state => state.isEditMode,
      modalData: state => state.data,
    }),
  },
  methods: {
    ...designerMapActions([
      'setEditRowSectionsModalState',
      'resetEditRowForm',
    ]),
    async onSend(event) {
      // Delegate to the shared content component
      if (this.$refs.editContent) {
        await this.$refs.editContent.onSend(event);
      }
    },
    onChangedRow(params) {
      // Forward the changed-row event
      this.$emit('changed-row', params);
    },
  },
  beforeDestroy() {
    if (this.defaultFormBackup) {
      this.resetEditRowForm(this.defaultFormBackup);
    }
  },
  created() {
    if (this.modalData?.ModalHeight && this.modalData?.ModalWidth) {
      document.body.style.setProperty('--height', this.modalData.ModalHeight);
      document.body.style.setProperty('--width', this.modalData.ModalWidth);
    }
  },
  beforeMount() {
    if (this.defaultForm) {
      this.defaultFormBackup = JSON.parse(JSON.stringify(this.defaultForm));
    }
  },
};
</script>

<style lang="scss">
.custom__dialog {
  width: var(--width) !important;
  max-width: var(--width) !important;
  min-width: var(--width) !important;
  height: var(--height) !important;
  min-height: var(--height) !important;
}
</style>